export enum HumanTaskOutcome {
  APPROVE = "APPROVE",
  REJECT = "REJECT",
  EXTENDED = "EXTENDED",
}
